/* Sehat — Herbal Premium Theme JS */
(function () {
  'use strict';

  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
    });
  }

  // Product gallery thumbnails
  var mainImage = document.getElementById('MainProductImage');
  if (mainImage) {
    document.querySelectorAll('.main-product__thumbs .thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-image');
        document.querySelectorAll('.main-product__thumbs .thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  // Variant selection
  var form = document.getElementById('ProductForm');
  if (form) {
    var variantsScript = form.querySelector('[data-variants-json]');
    var variantInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var priceEl = document.getElementById('ProductPrice');
    var selects = form.querySelectorAll('[data-option-select]');

    if (variantsScript && selects.length) {
      var variants = JSON.parse(variantsScript.textContent);

      var formatMoney = function (cents) {
        return 'Rs. ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
      };

      var onChange = function () {
        var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        });
        if (match) {
          variantInput.value = match.id;
          if (priceEl) {
            var html = '';
            if (match.compare_at_price && match.compare_at_price > match.price) {
              html += '<s>' + formatMoney(match.compare_at_price) + '</s> ';
              html += '<span class="price--sale">' + formatMoney(match.price) + '</span>';
            } else {
              html += '<span>' + formatMoney(match.price) + '</span>';
            }
            priceEl.innerHTML = html;
          }
          if (addButton) {
            addButton.disabled = !match.available;
            addButton.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
        } else if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
      };

      selects.forEach(function (s) { s.addEventListener('change', onChange); });
    }
  }
})();
